import BarChart05 from "@untitled-ui/icons-react/build/esm/BarChart05";
import BarLineChart from "@untitled-ui/icons-react/build/esm/BarLineChart";
import Calendar from "@untitled-ui/icons-react/build/esm/Calendar";
import Report from "@untitled-ui/icons-react/build/esm/CheckDone02";
import ChevronLeft from "@untitled-ui/icons-react/build/esm/ChevronLeft";
import CreditCardCheckIcon from "@untitled-ui/icons-react/build/esm/CreditCardCheck";
import Eye from "@untitled-ui/icons-react/build/esm/Eye";
import FileCheck02 from "@untitled-ui/icons-react/build/esm/File02";
import FileCheck01 from "@untitled-ui/icons-react/build/esm/FileCheck01";
import Unknown from "@untitled-ui/icons-react/build/esm/FileQuestion01";
import Grid01 from "@untitled-ui/icons-react/build/esm/Grid01";
import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";
import Lightbulb05 from "@untitled-ui/icons-react/build/esm/Lightbulb05";
import LineChartUp01 from "@untitled-ui/icons-react/build/esm/LineChartUp01";
import Link05 from "@untitled-ui/icons-react/build/esm/Link05";
import Mail from "@untitled-ui/icons-react/build/esm/Mail05";
import Microscope from "@untitled-ui/icons-react/build/esm/Microscope";
import Monitor04 from "@untitled-ui/icons-react/build/esm/Monitor04";
import PackagePlus from "@untitled-ui/icons-react/build/esm/PackagePlus";
import PackageSearch from "@untitled-ui/icons-react/build/esm/PackageSearch";
import Palette from "@untitled-ui/icons-react/build/esm/Palette";
import PasscodeLock from "@untitled-ui/icons-react/build/esm/PasscodeLock";
import PencilLine from "@untitled-ui/icons-react/build/esm/PencilLine";
import Plus from "@untitled-ui/icons-react/build/esm/Plus";
import PresentationChart01 from "@untitled-ui/icons-react/build/esm/PresentationChart01";
import Ruler from "@untitled-ui/icons-react/build/esm/Ruler";
import Scale02 from "@untitled-ui/icons-react/build/esm/Scale02";
import Snowflake02 from "@untitled-ui/icons-react/build/esm/Snowflake02";
import Trash from "@untitled-ui/icons-react/build/esm/Trash01";
import Upload01 from "@untitled-ui/icons-react/build/esm/Upload01";
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import { ReactComponent as FileInvoiceSolid } from "../../../assets/icons/file-invoice-solid.svg";
import ControlbarSearch from "../forms/ControlbarSearch";

// #region  SCOPED CSS
const StyledPage = styled.div`
    .controlbar {
        background: linear-gradient(180deg, rgba(36, 38, 39, 0.65), rgba(15, 17, 18, 0.96)), #141617;
        box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.025);
        box-sizing: border-box;
        display: flex;
        flex-flow: row wrap;
        left: 0;
        max-width: 100%;
        padding: 0 24px;
        //position: fixed;
        right: 0;
        top: 70px;
        z-index: 1;
    }

    /* The side groups stay balanced and wrap only when their content no longer fits. */
    .product-search.left-side,
    .right-control-search {
        flex: 1 1 0;
        min-width: max-content;
    }

    // LEFT SIDE
    .product-search.left-side {
        align-items: center;
        display: flex;
        height: 62px;
        justify-content: flex-start;
        padding-top: 5px;
        text-align: center;
    }

    .product-search.left-side .btn.btn-success {
        align-items: center;
        display: flex;
        justify-content: center;
        margin: 0;
    }

    .product-search.left-side .btn.btn-success i {
        font-size: 17px;
    }

    .controlbar .btn.btn-success {
        align-items: center;
        color: var(--text-icons-gray-100);
        display: flex;
        font-family: Roboto, sans-serif;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.3px;
        text-decoration: none;
        justify-content: center;
        margin: 0 5px;
        text-transform: uppercase;
    }

    .controlbar .btn.btn-success {
        background: linear-gradient(180deg, #252729, #17191b);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
    }

    .product-search .btn.btn-success {
        align-items: center;
        display: flex;
        float: left;
        font-size: 16px;
        height: 37px;
        justify-content: center;
        line-height: 37px;
        padding: 0;
        width: 40px;
    }

    .button-not-active,
    .button-not-active .btn {
        color: var(--text-icons-gray-300) !important;
        cursor: not-allowed;
    }

    .button-not-active .search-predict-text {
        color: var(--text-icons-gray-300) !important;
    }

    .search-predict-text.text-center {
        float: none;
        justify-content: center;
        font-size: 10px;
    }

    .button-not-active .search-predict-text {
        color: var(--text-icons-gray-300) !important;
    }

    .search-predict-text.text-center {
        float: none;
        justify-content: center;
    }

    .search-predict-text {
        clear: both;
        color: var(--text-icons-gray-100);
        display: flex;
        float: left;
        font-size: 10px;
        text-align: center;
    }
    .search-predict-text {
        justify-content: flex-start;
    }

    // CENTER BUTTONS
    .centerbtn {
        align-items: center;
        display: flex;
        flex: 0 0 auto;
        gap: 10px;
        height: 62px;
        justify-content: center;
        min-width: max-content;
    }

    .centerbtn .btn.btn-success {
        height: 35px;
        padding-left: 0;
        padding-right: 0;
        min-width: 120px;
        line-height: normal;
        margin: 0;
        padding: 10px;
    }
    .controlbar .btn.btn-success {
        background: linear-gradient(180deg, #252729, #17191b);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035);
    }
    .controlbar .btn.btn-success.active {
        border-color: var(--text-icons-green-500);
    }

    // RIGHT SIDE
    .right-control-search {
        display: flex;
        justify-content: flex-end;
        min-height: 62px;
    }

    .product-search.right-side {
        float: right;
        align-items: center;
        display: flex;
        justify-content: flex-end;
    }

    .right-control-search .product-search.right-side a {
        margin-left: 8px;
        display: inline-grid;
        place-content: center;
    }

    .controlbar .right-control-search .btn.btn-success {
        margin: 0;
    }
    .controlbar .btn.btn-success.active {
        border-color: var(--text-icons-green-500);
    }

    .controlbar .btn-icon i {
        font-size: 12px !important;
    }

    .right-control-search .search-predict-text {
        justify-content: center;
        width: 100%;
        font-size: 10px;
        height: 10px;
    }

    .search-predict-text {
        clear: both;
        color: var(--text-icons-gray-100);
        display: flex;
        float: left;
        font-size: 10px;
        text-align: center;
    }
    .search-predict-text {
        justify-content: flex-start;
    }

    .navbar-nav.ml-auto .nav-item.logoutbtn,
    .right-control-search .product-search.right-side:last-child a {
        margin-right: 0;
    }

    .controlbar .centerbtn .btn.btn-success:not(.button-not-active):not(.active):hover,
    .controlbar .right-side a:hover .btn.btn-success:not(.button-not-active):not(.active),
    .controlbar .left-side > [role="button"]:not(.button-not-active):not(.active):hover .btn.btn-success {
        background: linear-gradient(180deg, #302c25, #211f1b);
        border-color: rgba(239, 191, 115, 0.55);
    }
    .controlbar .left-side > .active:not(.button-not-active) .btn.btn-success {
        border-color: var(--text-icons-green-500);
    }
    .controlbar .btn.btn-success.active {
        background: linear-gradient(180deg, #252a25, #171b18);
    }
    .controlbar .btn.btn-success.button-not-active,
    .controlbar .button-not-active .btn.btn-success {
        background: #17191b;
        border-color: rgba(255, 255, 255, 0.07);
        box-shadow: none;
    }
    .controlbar .btn.btn-success {
        transition: border-color 140ms ease, background-color 140ms ease;
    }
    .controlbar a:focus-visible {
        /* Restore keyboard focus suppressed by the existing global link rule. */
        outline: 2px solid #efbf73 !important;
        outline-offset: 2px !important;
        border-radius: 6px;
    }
    .controlbar .right-side a { text-decoration: none; }

    /* The measured CustomSearch frame owns the only input surface. */
    .controlbar .CustomSearch .FormField.custom-search {
        background: transparent;
        border: 0;
        border-radius: 6px;
        box-shadow: none;
    }
    .controlbar .CustomSearch .FormField.custom-search .Frame48 {
        box-sizing: border-box;
        height: 37px;
        background: #0e0f10;
        border: 0;
        border-radius: 6px;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    }
    .controlbar .CustomSearch .FormField.custom-search .Frame48Input {
        background: transparent;
        min-width: 0;
        min-height: 0;
        height: 100%;
        padding-right: 20px;
    }
    .controlbar .CustomSearch .FormField.custom-search .Frame48:focus-within {
        outline: 2px solid #efbf73;
        outline-offset: 1px;
    }
    .controlbar .search-container .frame-48 {
        background: #0e0f10;
        border-color: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
    }
    .controlbar .search-container .frame-48:focus-within {
        outline: 2px solid #efbf73;
        outline-offset: 1px;
    }
    .controlbar .search-container .input-field-dropdown {
        background: linear-gradient(145deg, #202224, #141617 55%, #0e0f10);
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.3);
    }
    .controlbar .search-container .frame-78 { border-radius: 5px; }
    .controlbar .search-container .frame-78:hover { background: rgba(239, 191, 115, 0.08); }
    @media (prefers-reduced-motion: reduce) {
        .controlbar .btn.btn-success { transition: none; }
    }
`;
// #endregion

/**
 * ControlBar component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.className - The class name for the component.
 * @param {Array<Object>} props.leftBtns - The array of left buttons.
 * @param {boolean} props.leftBtns[].visible - Indicates if the button is visible.
 * @param {boolean} props.leftBtns[].active - Indicates if the button is active.
 * @param {boolean} props.leftBtns[].disabled - Indicates if the button is disabled.
 * @param {string} props.leftBtns[].icon - The icon name for the button.
 * @param {string} props.leftBtns[].title - The title for the button.
 * @param {Function} props.leftBtns[].onClick - The click event handler for the button.
 * @param {Function} props.leftBtns[].isSearchToogle - Indicates if the button is a search toogle.
 * @param {JSX.Element} props.leftBtns[].customSearch - The custom search component.
 * @param {Array<Object>} props.centerBtns - The array of center buttons.
 * @param {string} props.centerBtns[].to - The link destination for the button.
 * @param {boolean} props.centerBtns[].disabled - Indicates if the button is disabled.
 * @param {boolean} props.centerBtns[].saveIt - Indicates if the button is a save button.
 * @param {boolean} props.centerBtns[].active - Indicates if the button is active.
 * @param {string} props.centerBtns[].title - The title for the button.
 * @param {Function} props.centerBtns[].onClick - The click event handler for the button.
 * @param {boolean} props.centerBtns[].ignoreUppercase - Indicates if the button title should be ignored for uppercase.
 * @param {Array<Object>} props.rigthBtns - The array of right buttons.
 * @param {string} props.rigthBtns[].to - The link destination for the button.
 * @param {boolean} props.rigthBtns[].disabled - Indicates if the button is disabled.
 * @param {boolean} props.rigthBtns[].active - Indicates if the button is active.
 * @param {boolean} props.rigthBtns[].visible - Indicates if the button is visible.
 * @param {string} props.rigthBtns[].icon - The icon name for the button.
 * @param {string} props.rigthBtns[].title - The title for the button.
 * @param {Function} props.rigthBtns[].onClick - The click event handler for the button.
 * @returns {JSX.Element} The rendered ControlBar component.
 */
export default function ControlBar(props) {
    // #region VARS
    const navigate = useNavigate();
    const [useSearch, setUseSearch] = React.useState(false);
    const [searchVisible, setSearchVisible] = React.useState(false);

    const isValidBoImagePath = window.location.pathname.startsWith("/boimages");
    const isValidRetailerPath = window.location.pathname.startsWith("/retailers");
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (isValidBoImagePath || isValidRetailerPath) {
            setUseSearch(true);
        } else {
            setUseSearch(false);
        }
    }, [window.location.pathname]);
    // #endregion

    return (
        <StyledPage className={props?.className || ""}>
            <div className="controlbar">
                <div className="product-search left-side">
                    {props?.leftBtns?.map(btn => {
                        const key = uuidv4();
                        if (btn?.visible === false) return null;
                        if (btn?.customSearch) return btn?.customSearch;

                        return (
                            <span
                                key={key}
                                data-widget="search"
                                className={`${btn?.active ? "active" : ""} ${btn?.disabled ? "button-not-active" : ""}`}
                                to="#"
                                onClick={e => handleOnClick(e, btn, setSearchVisible, searchVisible)}
                                role="button">
                                <span className="btn btn-success btn-icon">{getIcon(btn?.icon)}</span>
                                <span
                                    className={`search-predict-text text-center ${
                                        btn?.disabled ? " text-not-active" : ""
                                    }`}>
                                    {btn?.title}
                                </span>
                            </span>
                        );
                    })}

                    {/* TODO: MAKE THIS SEARCH WORK WITH ANY VIEW */}
                    {/*TEMP: if route starts with  /boimages, show this search: */}
                    {useSearch && searchVisible && (
                        <ControlbarSearch
                            //style={{ top: "-6px", marginLeft: "6px" }}
                            apiName={isValidBoImagePath ? "searchBOimages" : ""} //searchRetailBrands it is removed will be used later with different endpoint name
                            apiNameField="name"
                            includeInAPIFormData={{ companyID: localStorage.getItem("currentCompanyID") }}
                            useBOcommon={true}
                            BOCommonContext={"BOImages"}
                            onItemSelected={item => {
                                if (isValidBoImagePath) {
                                    navigate(`/boimages/${item._id}`);
                                } else if (isValidRetailerPath) {
                                    if (item?.name) {
                                        navigate(`/retailers/invite?name=${item.name}`);
                                    } else if (item?._id) {
                                        navigate(`/retailers/invite?id=${item._id}`);
                                    }
                                }
                            }}
                        />
                    )}
                </div>
                <div className="centerbtn">
                    {props?.centerBtns?.map(btn => {
                        const key = uuidv4();
                        return (
                            <span
                                key={key}
                                onClick={btn?.to && !btn?.disabled ? () => navigate(btn?.to) : undefined}
                                to={btn?.disabled ? "#" : btn?.to}
                                className={`btn btn-success ${btn?.saveIt ? "saveIt" : ""} ${
                                    btn?.active ? "active" : ""
                                } ${btn?.disabled ? "button-not-active" : ""}
                                ${btn?.ignoreUppercase ? "text-transform-none" : ""}
                                `}>
                                {btn?.title}
                            </span>
                        );
                    })}
                </div>
                <div className="right-control-search">
                    {props?.rigthBtns?.map(btn => {
                        const key = uuidv4();
                        return (
                            <div
                                key={key}
                                className={`product-search right-side saveIt ${btn?.visible === false ? "d-none" : ""}`}>
                                <Link
                                    data-widget="search"
                                    to={btn?.to}
                                    role="button"
                                    onClick={e =>
                                        btn?.disabled
                                            ? e.preventDefault()
                                            : handleOnClick(e, btn, setSearchVisible, searchVisible)
                                    }>
                                    <span
                                        className={`btn btn-success btn-icon ${btn?.active ? "active" : ""} ${
                                            btn?.disabled ? "button-not-active" : ""
                                        }`}>
                                        {getIcon(btn?.icon)}
                                    </span>
                                    <span className={`search-predict-text ${btn?.disabled ? " text-not-active" : ""}`}>
                                        {btn?.title}
                                    </span>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </StyledPage>
    );
}

// #region METHODS
function handleOnClick(e, btn, setSearchVisible, searchVisible) {
    try {
        if (btn?.isSearchToogle) {
            setSearchVisible(!searchVisible);
        }
        if (btn?.disabled || !btn?.to) e.preventDefault();
    } catch (e) {}
    if (btn?.onClick) {
        btn?.onClick(e);
    }
}

function getIcon(iconName) {
    if (iconName?.includes("fa-")) {
        return <i className={`fa-light ${iconName}`}></i>;
    }
    iconName = iconName?.replace("fa-solid ", "")?.replace("fa-", "");

    switch (iconName?.toLowerCase()) {
        case "eye":
        case "view":
        case "show":
            return <Eye height="16px" />;
        case "plus":
        case "add":
        case "new":
            return <Plus height="16px" />;
        case "file-invoice-solid":
            return <FileInvoiceSolid size="16" />;
        case "credit-card-check":
            return <CreditCardCheckIcon height="16px" />;
        case "mail":
            return <Mail height="16" />;
        case "microscope":
        case "details":
            return <Microscope height="16px" />;
        case "pencil-line":
        case "edit":
            return <PencilLine height="16px" />;
        case "chevron-left":
            return <ChevronLeft height="16px" />;
        case "file-check-01":
            return <FileCheck01 height="16px" />;
        case "file-check-02":
            return <FileCheck02 height="16px" />;
        case "trash":
        case "garbage":
        case "delete":
        case "remove":
            return <Trash height="16px" />;
        case "file-03":
            return <Report height="16px" />;
        case "bar-line-chart":
            return <BarLineChart height="16px" />;
        case "info-circle":
            return <InfoCircle height="16px" />;
        case "package-search":
            return <PackageSearch height="16px" />;
        case "calendar":
            return <Calendar height="16px" />;
        case "package-plus":
            return <PackagePlus height="16px" />;
        case "passcode-lock":
            return <PasscodeLock height="16px" />;
        case "monitor":
        case "monitor-04":
            return <Monitor04 height="16px" />;
        case "bar-chart-05":
            return <BarChart05 height="16px" />;
        case "upload":
        case "upload-01":
            return <Upload01 height="16px" />;
        case "snowflake-02":
            return <Snowflake02 height="16px" />;
        case "link-05":
            return <Link05 height="16px" />;
        case "ruler":
            return <Ruler height="16px" />;
        case "palette":
            return <Palette height="16px" />;
        case "grid-01":
            return <Grid01 height="16px" />;
        //ADD NEW ICONS HERE
        case "presentation-chart-01":
            return <PresentationChart01 height="16px" />;
        case "lightbulb-05":
            return <Lightbulb05 height="16px" />;
        case "scale-02":
            return <Scale02 height="16px" />;
        case "line-chart-up-01":
            return <LineChartUp01 height="16px" />;

        default:
            console.error("Unknown untitled-ui icon: " + iconName);
            return <Unknown />;
    }
}
// #endregion
